import { Link, Navigate } from 'react-router-dom';
import React, { useContext, useEffect } from 'react';
import { RxChevronRight } from 'react-icons/rx';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import '../home.css'
import Header from '../Components/header/Header';
import UserDetails from '../context/UserDetails';

const Page = () => {


  const { user, token } = useContext(UserDetails)

  const formated = new Intl.NumberFormat('en-IN').format(user?.balance)

  if(!token){
    return <Navigate to='/' />
  }

  return (
    <div className='mobile-layout'>
      <div className='scroll-y'>
        <Header />
        <div>
          <div>
            <Tabs>
              <TabList>
                <Tab>Overview</Tab>
                <Tab disabled>Favourite</Tab>
              </TabList>

              <TabPanel>
                <div className='top-content'>
                  <div className='box'>
                    <div className='account-wrapper'>
                      <h3 className='mb-4 font-600'>ACCOUNTS</h3>
                      <Link className='flex justify-between' to={'/account'}>
                        <div>
                          <p className='text-light-blue mb-2 font-600'>Savings Account</p>
                          <div className='flex gap-2 text-light-blue font-500'>
                            <p><strong>&#8377;</strong></p>
                            <p>{formated.slice(0,formated.length-2)}{formated.slice(formated.length-2)}</p>
                          </div>
                        </div>
                        <span >
                          <RxChevronRight color='#025395' size={20} />
                        </span>
                      </Link>
                    </div>
                    <div className='view-btn-wrapper'>
                      <Link className='block w-100 text-center py-5 link' to={''}>View All</Link>
                    </div>
                  </div>
                </div>
                <div className='bottom-content py-4'>
                  <div className='box p-4'>
                    <div className='grid grid-cols-3 gap-5'>
                      <div className='home-grid-item'>
                        <div className='img-wrapper'>
                          <img width={50} height={50} src={'/bill-payment.png'} alt='bil-payment' />
                        </div>
                        <p className='whitespace-nowrap'>Bill payments</p>
                      </div>
                      <div className='home-grid-item'>
                        <div className='img-wrapper'>
                          <img width={50} height={50} src={'/money-transfer.png'} alt='money-transfer' />
                        </div>
                        <p className='whitespace-nowrap'>Money Transfer</p>
                      </div>
                      <div className='home-grid-item'>
                        <div className='img-wrapper'>
                          <img width={50} height={50} src={'/add-payee.png'} alt='add-payee' />
                        </div>
                        <p className='whitespace-nowrap'>Add Payee</p>
                      </div>
                      <div className='home-grid-item'>
                        <div className='img-wrapper'>
                          <img width={50} height={50} src={'/scan_and_pay.png'} alt='scan & pay' />
                        </div>
                        <p className='whitespace-nowrap'>Scan & Pay</p>
                      </div>
                      <div className='home-grid-item'>
                        <div className='img-wrapper'>
                          <img width={50} height={50} src={'/recharge.png'} alt='recharge' />
                        </div>
                        <p className='whitespace-nowrap'>Recharge</p>
                      </div>
                      <div className='home-grid-item'>
                        <div className='img-wrapper'>
                          <img width={50} height={50} src={'/upi.png'} alt='upi' />
                        </div>
                        <p className='whitespace-nowrap'>UPI</p>
                      </div>
                    </div>
                  </div>
                  <h3 className='my-3'>Due Bills</h3>
                  <div className='box p-2 account-wrapper'>
                    <p className='text-center mb-3'>Register your biller and pay all your bill with 2 clicks</p>
                    <div>
                      <button className='block w-full py-2 btn-blue text-center'>ADD BILLER</button>
                    </div>
                  </div>
                </div>
                <div className='home-bottom-nav'>
                  <button>Pay</button>
                  <button>Save</button>
                  <button>Invest</button>
                </div>
              </TabPanel>
              {/*<TabPanel>
            Favourite content
          </TabPanel>*/}
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page